import React, { useState, useEffect } from "react";
import QRCode from "qrcode";
import { Anchor, Button, Stack, Text, Group } from "@mantine/core";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const sizeButtons = [
  { label: "XS", width: 100 },
  { label: "SM", width: 150 },
  { label: "MD", width: 200 },
  { label: "LG", width: 250 },
  { label: "XL", width: 500 },
  { label: "XXL", width: 1200 },
].map((m, i) => ({
  ...m,
  key: i,
}));

export default function QrCodeGenerator({
  text = "hello",
  minimal = false,
  filename = "qr-code.png",
  isLink = true,
}) {
  const { t } = useTranslation();
  const [imgData, setImgData] = useState(null);
  const [size, setSize] = useState(250);

  useEffect(() => {
    if (text) {
      generateCode();
    }
  }, [text, size]);

  function generateCode(clicked = false) {
    QRCode.toDataURL(text, {
      width: size,
    })
      .then((url) => {
        setImgData(url);
        if (clicked) {
          toast.success(t("mixer:qr_code_generated"));
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  if (minimal && imgData) {
    return (
      <a href={imgData} download={filename}>
        <img
          style={{
            width: "250px",
            maxWidth: "250px",
            display: "block",
          }}
          src={imgData}
          alt="QR Code"
          title={filename}
        />
      </a>
    );
  }

  return (
    <React.Fragment>
      <Text fw="bold">
        {t("mixer:qr_code_generator:title", { size: size })}
      </Text>
      <Text size="xs" c="dimmed">
        {t("mixer:qr_code_generator:subtitle")}
      </Text>
      <Stack align="flex-start" mt="lg">
        <Group position="start" spacing="sm">
          {sizeButtons.map((b) => {
            return (
              <Button
                variant={size === b.width ? "filled" : "outline"}
                size="sm"
                key={b.key}
                onClick={() => setSize(b.width)}
              >
                {b.label}
              </Button>
            );
          })}
        </Group>
        {imgData && (
          <React.Fragment>
            <a href={imgData} download={filename}>
              <img
                style={{
                  width: "250px",
                  maxWidth: "250px",
                  display: "block",
                  boxShadow: "1px 1px 5px #ccc",
                }}
                src={imgData}
                alt="QR Code"
                title={filename}
              />
            </a>
            <Text fw={700}>
              {t("mixer:qr_code_generator:click_to_download")}
            </Text>
            {isLink ? (
              <Text>
                {t("mixer:qr_code_generator:url_prefix_text")}{" "}
                <Anchor href={text} target="_blank">
                  {text}
                </Anchor>
              </Text>
            ) : (
              <Text size="xs" c="dimmed">
                {text}
              </Text>
            )}
          </React.Fragment>
        )}
        {/* <Button
        leftSection={<IconQrcode />}
        variant="light"
        onClick={() => generateCode(true)}
      >
        Generate QR Code
      </Button> */}
      </Stack>
    </React.Fragment>
  );
}
